import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzResultModule } from 'ng-zorro-antd/result';
import { take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { StripeService } from '../../../core/stripe/stripe.service';

@Component({
  selector: 'app-upgrade-to-premium',
  standalone: true,
  imports: [CommonModule, FormsModule, NzButtonModule, NzIconModule, NzResultModule],
  templateUrl: './upgrade-to-premium.component.html',
  styleUrl: './upgrade-to-premium.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeToPremiumComponent {
  constructor(
    private router: Router,
    private stripeService: StripeService,
    private messageService: NzMessageService
  ) {}

  onUpgradeClick() {
    if (this.stripeService.getSubscription()) {
      this.stripeService
        .getCustomerPotalUrl$()
        .pipe(take(1))
        .subscribe((data) => {
          if (data) {
            window.open(data, '_blank');
          } else {
            this.messageService.error(`Cannot update the subscription. Please contact us: ${environment.supportEmail}`);
          }
        });
    } else {
      this.router.navigate(['/pricing']);
    }
  }
}
